import axios from "axios";
import { server } from "../utils/helper";

const PayrollService = {
    sendFile: (formData) => {
        const headers = { 'Content-Type': 'multipart/form-data' };

        return axios.post(`${server.baseURL}/files`, formData, { headers })
            .then((res) => {
                return res.data;
            }
        ).catch(err => {
            console.log('err', err);
            throw new Error(err);
        });
    },
    calcTaxes: (formData) => {
        const headers = { 'Content-Type': 'application/json' };

        return axios.post(`${server.baseURL}/files/calc-taxes`, formData, { headers })
            .then((res) => {
                return res.data;
            }
        ).catch(err => {
            console.log('err', err);
            return null;
        });
    }
}

export default PayrollService